var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoltshot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.6129 16.1219C12.6129 16.1219 17.9709 10.9979 18.6519 10.9694C19.3329 10.9409 58.5774 9.2804 58.5774 9.2804L59.9994 8.2109L67.0239 7.7609L69.1074 6.8594L72.5559 6.6599L82.9554 6.1319L81.4404 2.4104H82.9554L84.9294 6.0329L89.8869 5.7884L94.7304 11.3639L99.3204 14.4329L105.401 21.9509C105.401 21.9509 106.223 23.4194 106.289 23.7254C106.355 24.0314 106.418 30.6614 106.418 30.6614L105.823 32.7629L104.189 35.4239L103.964 37.2404V43.4069L103.735 44.7299L101.219 49.1504H97.5024L94.7574 47.7104L94.7454 40.9349L95.6019 39.4349V36.6899L94.3764 34.3664V28.1159L92.2644 25.6244H90.1104L85.7604 29.7629H83.9859C83.9859 29.7629 83.8434 35.3489 83.3949 35.9294C82.9464 36.5099 82.6764 37.1549 82.6764 37.1549V38.7179L83.3514 39.7319L83.2389 41.3789L81.9579 42.5189V43.9964L82.5909 45.0104L85.2654 44.9759L86.7714 45.3914L88.7139 45.4334L89.5164 46.1939L90.6144 46.4474L91.4589 47.2499L91.3749 51.5999L85.7784 57.0344L72.4539 57.2594L70.4274 56.5844L70.5114 54.7259L67.6389 53.8814L66.5124 54.4364L65.8644 55.2329L61.8939 55.3169L54.0384 52.5299H48.1254C47.6184 52.5299 40.4394 50.8409 40.4394 50.8409L37.9899 49.7009L28.1349 49.0274L26.5014 47.8004V42.5639L27.0369 41.8319L26.9244 40.5374C26.9244 40.5374 25.3269 39.4994 25.3194 39.3974C25.3119 39.2954 25.0929 36.2639 25.0929 36.2639L24.7284 35.1734L23.6169 35.0324L22.5804 33.8654L22.7439 29.5139L23.6904 28.8584L22.3224 26.5139L18.6474 26.5559L16.2819 24.0224V21.6719L15.0999 19.5464L14.1129 19.4204L12.6084 16.1264L12.6129 16.1219Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7354 35.6864L71.1788 33.8594H72.4598L77.4864 39.0119L77.2748 42.2219L78.0623 43.1519H79.1333L80.2313 42.2639L81.4419 30.3539L83.6379 28.4534",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5222 46.065H76.4302L73.2622 42.4755L71.9107 42.729L66.5182 36.3945H62.0707L61.5637 37.041H51.3712L48.8362 35.802H39.9952L38.5882 36.648H32.2807L31.5487 36.0285H25.0732",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5176 47.709H87.9736V50.331L86.6221 51.5145H83.3551L81.9481 52.752H76.0906L75.0886 51.288H73.8391",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0911 52.752V57.033",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2429 57.033L89.1559 51.6825V49.9365L90.1129 49.698V48.5295L89.5219 47.709V46.1925",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1416 13.3349L44.1061 12.8834L47.1436 9.76343",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2091 13.335H62.5771",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3359 12.432L76.4059 11.664",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.406 11.664L78.3725 11.5485L79.682 10.293L93.146 9.53999L91.6025 7.76099L73.3025 8.73749",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.279 19.923C98.279 19.923 95.351 21.2745 95.6615 25.4985L100.223 30.621L100.25 43.8L99.4055 47.361H102.312",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9244 49.698H56.6074L58.9729 48.726H65.3359L64.6039 47.709H58.2964L56.1859 48.558H41.4424",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2375 49.5435V51.0345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3486 28.749V27.075L69.6301 24.1455H81.0466L83.6371 26.6235V28.4535H80.6521L76.8511 26.1165H71.1781L69.6301 27.9045H68.6161L67.3486 28.749ZM67.3486 28.749V34.155L68.7346 35.6865L75.4936 43.152H78.0616",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6309 27.9045H79.7604",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9911 32.2544H68.7346V30.6599H71.1781V29.7209H67.3486",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3932 36.3945L62.2952 38.505H51.8207L50.8637 39.1815H49.3427L47.4842 37.83H41.4422L40.2767 38.3925H35.6027L34.7027 37.83H27.8057V38.505L28.9577 39.4635V40.9335H39.7697L41.4422 42.4755H51.6527L53.3882 41.3775H62.3507L62.2952 38.505",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3509 41.3775L64.2094 41.94V43.5735L63.5899 44.7285H61.6189L60.3799 46.1925",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3439 38.4495H66.0739C65.8221 38.4495 65.6179 38.6536 65.6179 38.9055V43.8495C65.6179 44.1013 65.8221 44.3055 66.0739 44.3055H66.3439C66.5958 44.3055 66.7999 44.1013 66.7999 43.8495V38.9055C66.7999 38.6536 66.5958 38.4495 66.3439 38.4495Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8474 28.749V35.127H24.7354V28.749V24.8775H25.8619H37.6429L38.4754 26.1165L38.5879 36.648",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8623 24.8774V36.0284",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2852 23.7239L42.3602 26.4554H57.2972L58.5227 25.4969H61.7312L63.8717 27.0749V28.4534H65.9267L66.2087 26.5679L63.3932 23.9204H56.8892H55.7057L39.2852 23.7239Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2855 23.724H32.3795L30.563 22.4565H27.5225L26.9315 22.9215H26.087L22.6655 21.2745V18.084V19.1625L18.8645 19.0785L18.2315 19.542H15.1055",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2094 28.4535C64.2094 28.4535 64.4059 34.62 64.2094 34.62H61.2244",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.21 34.6199H65.9275V28.4534",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7588 40.2794L96.6173 42.7709L97.5053 41.0819V39.3074L95.6033 36.6899",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6169 42.771V49.149",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M101.037 37.7041H102.572",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.037 29.7209L103.079 28.4534",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9298 6.03289C87.9343 5.88439 89.8873 5.78839 89.8873 5.78839L94.7308 11.3639L99.3208 14.4329L105.402 21.9509C105.402 21.9509 106.5 23.2184 106.416 24.9074C106.332 26.5964 106.42 30.6614 106.42 30.6614C106.42 30.6614 106.669 31.4114 105.825 32.7629C104.98 34.1144 104.643 34.7894 104.643 34.7894C104.643 34.7894 103.968 35.5499 103.968 36.9014V43.4054C103.968 43.4054 104.094 44.3339 103.207 45.8549C102.321 47.3759 101.223 49.1489 101.223 49.1489H97.0843L94.6348 47.2904L94.7608 40.2794L95.6053 39.4349V36.6899L94.3798 34.3664V28.1159L92.2678 25.6244H90.1138L85.7638 29.7629H83.9893L83.3983 35.9294L82.6798 36.8579V38.7164L83.3548 39.3494V41.6729L81.9613 42.5174V43.9949L82.5943 45.0089L85.8044 44.9669L86.7763 45.3899L88.7188 45.4319L89.5213 46.1924L90.6193 46.4459L91.4638 47.2484L91.3798 51.5984L85.5509 57.2579H72.4588L70.4323 56.5829L70.5163 54.7244L68.1508 53.8799H66.9688L65.8708 55.2314L61.9003 55.3154L54.0448 52.5284H47.6248L40.4443 50.8394L38.6698 49.9109L27.6044 48.9824L26.5064 47.8004V42.5639L27.0973 42.4799L26.9279 40.5374L25.3229 39.3974L25.0694 35.8919L24.7319 35.1734L23.7179 35.1314L22.5779 33.9914L22.7474 29.5139L23.8454 28.7534L22.3244 26.5154L18.6494 26.5574C18.6494 26.5574 16.2839 24.1499 16.2839 24.0239V21.1949L15.1019 19.6739L14.1734 19.5479L12.6104 16.1264L18.6494 10.9739L58.5748 9.28489C58.5748 9.28489 58.9978 8.60989 59.9968 8.21539C60.9958 7.82089 67.0213 7.76539 67.0213 7.76539C67.0213 7.76539 67.9228 6.97639 69.1048 6.86389C69.8263 6.79489 77.1538 6.42439 82.9528 6.13639",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7693 28.9184L45.5143 28.9604L46.6543 29.4254L52.9888 29.5094L54.7213 28.7924L61.2253 28.6649V34.5359L57.7198 34.5779L56.2408 35.4224H51.3838L49.2298 34.4084H40.0648L39.7693 27.5669H61.2253V28.6649",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6133 16.1219L21.3553 15.9809L24.0583 14.9384L56.7478 14.0939L58.3528 14.6864L65.9548 14.6009V12.9119L62.5768 10.2929H60.3793L58.9723 8.88586",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.178 6.7334L78.6255 13.7564H84.1995L85.551 12.5039H88.593L97.5045 14.9669",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.037 27.0734C102.778 27.0734 104.19 25.6617 104.19 23.9204C104.19 22.179 102.778 20.7674 101.037 20.7674C99.2957 20.7674 97.884 22.179 97.884 23.9204C97.884 25.6617 99.2957 27.0734 101.037 27.0734Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.037 25.2719C101.783 25.2719 102.388 24.6668 102.388 23.9204C102.388 23.174 101.783 22.5689 101.037 22.5689C100.29 22.5689 99.6853 23.174 99.6853 23.9204C99.6853 24.6668 100.29 25.2719 101.037 25.2719Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M102.388 18.2264L98.2784 19.9229H91.5209L88.6484 22.5689L69.9674 22.8794L69.6299 20.7674L71.9099 17.9804H76.8089L78.1184 17.3039H83.1434L83.9954 16.7129H96.3629L97.4609 16.1219L97.5044 14.9669H99.7529",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9096 17.9803L58.8596 18.2338L56.5511 17.3323H41.6276L40.0511 18.2338H35.8271H34.8701H26.1416L25.0721 17.7823H13.3721",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8706 18.234L33.7441 19.641L35.4901 21.837L60.3241 22.119L61.6186 20.43L65.5051 20.4855L66.5176 19.641V18.084",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1006 42.4753L32.3371 46.0513H47.9911L49.0621 46.8958H56.8321L57.9586 46.2208H65.1661L68.4886 49.8808H72.2626L73.8391 51.1198V52.2463H71.1781H59.5336L56.7766 51.0628L51.2011 51.1198L40.3336 48.1918L40.2211 46.0513",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M71.178 52.2464L73.332 54.3299V57.2579",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7461 27.075H34.1381",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3254 32.6489L28.9574 30.9599",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1323 29.9999L78.0613 31.0709",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M83.637 19.4159L85.2705 20.7674",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65.335 22.1189L66.517 23.3579",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7656 24.8774L49.3421 26.1164",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7515 39.9705L44.668 41.6025",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2345 43.7984L68.208 45.6569",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9768 48.7259L78.0613 50.6684",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9564 6.1304L85.5514 12.5039H87.5224L83.2429 2.4104H81.4414L82.9564 6.1304Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5917 45.2488L27.8057 45.8653",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltshot);
export default __webpack_public_path__ + "static/media/Boltshot.80ece1662b7abeb228ec2fa449ad35ad.svg";
export { ForwardRef as ReactComponent };